import clsx from "clsx";
import Image from "next/image";

import arrowIcon from "@/assets/icons/arrow_right_gray.svg";
import attentionIcon from "@/assets/icons/attention-circle.svg";
import informationIcon from "@/assets/icons/information.svg";
import reportIcon from "@/assets/icons/report-active.svg";

type Props = {
  children: React.ReactNode;
  icon?: string;
  isArrow?: boolean;
  isGray?: boolean;
  isNoMargin?: boolean;
  isAttention?: boolean;
  isReportIconEnabled?: boolean;
  isGrayAndAttention?: boolean; //アイコンは注意、背景はグレー
};

/* インフォメーション */
const Information: React.FC<Props> = ({
  children,
  icon,
  isArrow,
  isGray,
  isNoMargin,
  isAttention,
  isReportIconEnabled,
  isGrayAndAttention
}) => {
  return (
    <div
      className={`${isNoMargin ? "" : "mx-16"} rounded-sm ${
        isAttention
          ? "bg-[#FFEEF1]"
          : isGray || isGrayAndAttention
            ? "bg-[#F5F5F5]"
            : "bg-[#DDF7F6]"
      } px-8 py-8`}
    >
      <div className="flex items-center">
        <div
          className={clsx(
            "flex w-full items-center gap-8",
            isArrow && "grow cursor-pointer"
          )}
        >
          <div className="-mb-1 min-h-16 min-w-16">
            <Image
              src={
                icon
                  ? icon
                  : isReportIconEnabled
                    ? reportIcon
                    : isAttention || isGrayAndAttention
                      ? attentionIcon
                      : informationIcon
              }
              alt={
                isReportIconEnabled
                  ? "reportIcon"
                  : isAttention || isGrayAndAttention
                    ? "attention"
                    : "information"
              }
              width={16}
              height={16}
            />
          </div>
          {children}
        </div>
        {isArrow && (
          <div className="-mb-1 min-h-16 min-w-16">
            <Image src={arrowIcon} alt="arrow" />
          </div>
        )}
      </div>
    </div>
  );
};

export default Information;
